import React, { useCallback, useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { ERROR_MSG } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import { CONSUMER_TIMELINE_DETAILS_ENDPOINT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import ProposalView from "../../timeline/ProposalView";
import SalesExecutiveWrapper from "../../timeline/SalesExecutiveWrapper";
const columns = ["Description", "Plan Details"];

/* @TODO => match fonts @habib610 Sat March 29,2025 */
const ConsumerProposal = () => {
    const { proposalId } = useParams();
    const [data, setData] = useState(null);

    const [currentSlide, setCurrentSlide] = useState(0);

    const [showSalesModal, setShowSalesModal] = useState(false);

    const { dispatch } = useContextState();

    let getTimelineDetails = useCallback(
        async (proposalId) => {
            try {
                dispatch({ type: SET_LOADER });
                let endpoint = `${CONSUMER_TIMELINE_DETAILS_ENDPOINT}${
                    proposalId ? `?proposalId=${proposalId}` : ""
                }`;
                let res = await request.authGet({ endpoint });
                setData(res?.data?.data);
                dispatch({ type: RESET_LOADER });
                return res;
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        },
        [dispatch]
    );

    useEffect(() => {
        if (proposalId && typeof proposalId === "number") {
            getTimelineDetails(proposalId);
        } else {
            getTimelineDetails();
        }
    }, [getTimelineDetails, proposalId]);

    return (
        <>
            <Container className="mt-5 py-[6rem] flex justify-center items-center">
                <ProposalView
                    secondSectionClass="xl:w-[40%]"
                    id={data?.proposalId}
                    currentSlide={currentSlide}
                    setCurrentSlide={setCurrentSlide}
                    setShowModal={setShowSalesModal}
                    url={"/proposal"}
                />
            </Container>
            <SalesExecutiveWrapper
                setShowModal={setShowSalesModal}
                showModal={showSalesModal}
                assignee={data?.assignee}
            />
        </>
    );
};

export default ConsumerProposal;
